import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import { entitiesPrintTitleHash } from 'utils/helpers/entities';
import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';

const PrintButton = ({ entityType, tabIndex }) => {
	const text = 'Распечатать';
	const tooltip = entitiesPrintTitleHash[entityType]
		? `${text} ${entitiesPrintTitleHash[entityType]}`
		: `${text} страницу`;

	const onClickButton = () => {
		window.print();
	};

	return (
		<Button
			icon="print"
			iconClassName={PVI_NO_STYLES_CLASSNAME}
			onClick={onClickButton}
			theme="circleGrayOutline"
			tooltip={tooltip}
			tabIndex={tabIndex}
			role="button"
		/>
	);
};

PrintButton.propTypes = {
	entityType: PropTypes.oneOf(['poems']),
	tabIndex: PropTypes.number
};

export default PrintButton;
